const VISUAL_TYPE_IMAGE_TYPE = {
  FILE: 'File',
  SVG: 'Svg',
};

const escapeXml = (value) =>
  String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&apos;');

const createSvgMarkup = ({ title, accent, glyph }) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 120" role="img" aria-label="${escapeXml(title)}">
  <defs>
    <linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#ffffff" />
      <stop offset="100%" stop-color="#eef3f8" />
    </linearGradient>
  </defs>
  <rect x="0" y="0" width="160" height="120" rx="18" fill="url(#bg)" />
  <rect x="10" y="10" width="140" height="100" rx="14" fill="#ffffff" stroke="#d6dee8" />
  <path d="${glyph}" fill="none" stroke="${accent}" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" />
  <circle cx="28" cy="24" r="4" fill="${accent}" />
</svg>`;

const glyphByShortName = {
  line: { accent: '#0f766e', glyph: 'M26 70 L56 48 L84 56 L114 34 L134 42' },
  bar: { accent: '#1d4ed8', glyph: 'M34 76 L34 52 M64 76 L64 38 M94 76 L94 58 M124 76 L124 28' },
  pie: { accent: '#c2410c', glyph: 'M80 28 A28 28 0 1 1 52 56 L80 56 Z M80 28 L80 56 L108 56' },
  scatter: { accent: '#9333ea', glyph: 'M38 68 L39 68 M64 46 L65 46 M88 58 L89 58 M116 36 L117 36 M128 66 L129 66' },
  effectScatter: { accent: '#7c3aed', glyph: 'M80 52 m-10 0 a10 10 0 1 0 20 0 a10 10 0 1 0 -20 0 M80 52 m-22 0 a22 22 0 1 0 44 0 a22 22 0 1 0 -44 0' },
  pictorialBar: { accent: '#2563eb', glyph: 'M34 76 L34 64 M34 58 L34 46 M66 76 L66 62 M66 56 L66 42 M98 76 L98 52 M98 46 L98 32 M130 76 L130 60 M130 54 L130 38' },
  candlestick: { accent: '#be123c', glyph: 'M42 30 L42 82 M34 42 L50 42 M34 66 L50 66 M82 24 L82 76 M74 36 L90 36 M74 58 L90 58 M122 34 L122 88 M114 48 L130 48 M114 74 L130 74' },
  boxplot: { accent: '#7c2d12', glyph: 'M42 30 L42 82 M30 42 L54 42 M30 70 L54 70 M72 38 L72 76 M60 48 L84 48 M60 64 L84 64 M102 28 L102 84 M90 40 L114 40 M90 72 L114 72' },
  radar: { accent: '#0f766e', glyph: 'M80 28 L112 44 L104 82 L56 82 L48 44 Z M80 28 L80 82 M48 44 L112 44 M56 82 L104 82' },
  heatmap: { accent: '#b45309', glyph: 'M40 34 L120 34 M40 58 L120 58 M40 82 L120 82 M40 34 L40 82 M80 34 L80 82 M120 34 L120 82' },
  map: { accent: '#0369a1', glyph: 'M36 46 L60 30 L92 42 L122 30 L122 78 L94 90 L62 78 L36 92 Z' },
  lines: { accent: '#0284c7', glyph: 'M32 74 C52 40, 72 40, 92 74 S132 108, 132 42' },
  graph: { accent: '#4f46e5', glyph: 'M44 38 L80 58 L118 34 M44 38 L42 82 M80 58 L42 82 M80 58 L118 82' },
  tree: { accent: '#15803d', glyph: 'M42 30 L42 84 M42 42 L82 42 M42 72 L82 72 M82 42 L118 28 M82 72 L118 58 M82 72 L118 88' },
  treemap: { accent: '#0f766e', glyph: 'M32 30 L128 30 L128 86 L32 86 Z M72 30 L72 86 M72 56 L128 56' },
  sunburst: { accent: '#ea580c', glyph: 'M80 52 m-16 0 a16 16 0 1 0 32 0 a16 16 0 1 0 -32 0 M80 52 m-30 0 a30 30 0 1 0 60 0 a30 30 0 1 0 -60 0' },
  parallel: { accent: '#4338ca', glyph: 'M34 28 L34 86 M58 28 L58 86 M82 28 L82 86 M106 28 L106 86 M130 28 L130 86 M34 70 L58 42 L82 62 L106 34 L130 54' },
  sankey: { accent: '#7c3aed', glyph: 'M28 44 L58 44 C72 44, 72 60, 86 60 L132 60 M28 74 L58 74 C72 74, 72 58, 86 58 L132 58' },
  funnel: { accent: '#b91c1c', glyph: 'M32 30 L128 30 L104 54 L96 74 L64 74 L56 54 Z' },
  gauge: { accent: '#0ea5e9', glyph: 'M46 76 A34 34 0 0 1 114 76 M80 76 L104 52' },
  themeRiver: { accent: '#0f766e', glyph: 'M28 72 C46 46, 62 92, 82 60 S118 30, 132 58' },
  aiRenderHtml: { accent: '#2563eb', glyph: 'M34 34 L126 34 L126 86 L34 86 Z M48 48 L94 48 M48 62 L112 62 M48 76 L98 76' },
  htmlCard: { accent: '#0f766e', glyph: 'M34 30 L126 30 L126 90 L34 90 Z M48 46 L112 46 M48 60 L98 60 M48 74 L88 74' },
  table: { accent: '#1d4ed8', glyph: 'M30 34 L130 34 M30 58 L130 58 M30 82 L130 82 M30 34 L30 94 M68 34 L68 94 M102 34 L102 94 M130 34 L130 94' },
  matrix: { accent: '#0f766e', glyph: 'M30 34 L130 34 M30 58 L130 58 M30 82 L130 82 M30 34 L30 94 M62 34 L62 94 M94 34 L94 94 M130 34 L130 94 M62 58 L94 58 M94 58 L130 82' },
  custom: { accent: '#475569', glyph: 'M40 42 L64 42 L64 66 L40 66 Z M72 34 L120 34 L120 50 L72 50 Z M72 58 L120 58 L120 74 L72 74 Z' },
};

export const buildVisualTypeImageOption = (visualTypeItem) => {
  const imageFileId = String(visualTypeItem?.ImageFileId ?? '').trim();
  if (imageFileId) {
    return {
      Image: imageFileId,
      ImageType: VISUAL_TYPE_IMAGE_TYPE.FILE,
    };
  }

  const shortName = String(visualTypeItem?.ShortName ?? '').trim();
  const fallback = glyphByShortName[shortName] ?? glyphByShortName.custom;
  const title = visualTypeItem?.FriendlyName ?? visualTypeItem?.Name ?? shortName ?? 'Visual';

  return {
    Image: createSvgMarkup({
      title,
      accent: fallback.accent,
      glyph: fallback.glyph,
    }),
    ImageType: VISUAL_TYPE_IMAGE_TYPE.SVG,
  };
};

export { VISUAL_TYPE_IMAGE_TYPE };
